export const HighlightDetectionTaggingMode = {
	CREATE_AND_RATE: 'create_and_rate',
	RATE_EXISTING:   'rate_existing',
};
